/* eslint-disable no-param-reassign */
import {
  getNode,
  insertElements,
  isElement,
  setElements,
} from '@udecode/plate-core';
import { canInsertBlock } from '../../editorTools/queries';
import { DreamWithOverride } from '../../plate';
import { SingleChildPlugin } from './types';

export const withSingleChild: DreamWithOverride<SingleChildPlugin> = (
  editor,
  { options: { rules = [] } },
) => {
  const { apply, normalizeNode } = editor;

  editor.apply = (operation) => {
    if (
      ((operation.type === 'insert_node' || operation.type === 'remove_node')
        && !canInsertBlock(editor, operation.path))
      || (operation.type === 'move_node'
        && !canInsertBlock(editor, operation.newPath))
    ) {
      throw new Error(
        'Parent element is not allowed to have more that one child',
      );
    }

    apply(operation);
  };

  editor.normalizeNode = (entry) => {
    const [, currentPath] = entry;

    if (!currentPath.length) {
      const endCurrentNormalizationPass = rules.some(({ type, path }) => {
        const childPath = [...path, 0];
        const child = getNode(editor, childPath);

        if (type) {
          if (child && isElement(child)) {
            if (child.type !== type) {
              setElements(editor, { type }, { at: childPath });
              return true;
            }
          } else {
            insertElements(
              editor,
              {
                type,
                children: [{ text: '' }],
              },
              { at: childPath },
            );
            return true;
          }
        }

        return false;
      });

      if (endCurrentNormalizationPass) {
        return;
      }
    }

    normalizeNode(entry);
  };

  return editor;
};
